export { TenderContractDashboardComponent } from './tender-contract-dashboard.component';
